import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import "./summary-element.module.css";

const SummaryElementBase = ({ element, template = "", externalLink = false }) => {
  const supportedTemplates = ["border", "simple"];
  const templateStyle = supportedTemplates.includes(template) ? `wrapper--${template}` : "wrapper";
  let text = element.text || "";
  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }

  return (
    <div styleName={templateStyle} data-testid="summary-element">
      <div styleName="heading-wrapper">
        <div styleName="line" />
        <h3 styleName="heading">Summary</h3>
        <div styleName="line" />
      </div>
      <div styleName="content" dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

SummaryElementBase.propTypes = {
  element: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  template: PropTypes.oneOf(["border", "simple", ""]),
  externalLink: PropTypes.bool
};

const mapStateToProps = state => ({
  template: get(state, ["qt", "config", "theme-attributes", "story-elements", "summary"], "")
});

export const SummaryElement = connect(
  mapStateToProps,
  {}
)(SummaryElementBase);
